<template>
    <notification-item
        title="Žádost o vstup do týmu"
        :created="data.created"
        :author="data.payload.userName"
        avatar="/img/myteam/Avatar.png"
        :link="{ name: 'userDetail', params: { id: data.payload.userId } }"
    >
        <p>Hráč <span class="semibold semibold--textgreen"><router-link :to="{ name: 'userDetail', params: { id: data.payload.userId } }">{{ data.payload.userName }}</router-link></span> vám posílá žádost o vstup do vašeho týmu <span class="semibold semibold--textgreen"><router-link :to="{ name: 'myTeam' }">{{ data.payload.teamName }}</router-link></span></p>
        <p>Žádost můžete přijmout nebo odmítnout.</p>

        <template v-slot:actions>
            <div class="news-notification__button">
                <v-btn
                    color="primary" dark
                    @click.prevent="accept"
                    :loading="accepting"
                    :disabled="declining"
                >
                    <v-icon left>mdi-check</v-icon> Přijmout
                </v-btn>
            </div>
            <div class="news-notification__button">
                <v-btn
                    color="primary" dark
                    @click.prevent="decline"
                    :loading="declining"
                    :disabled="accepting"
                >
                    <v-icon left>mdi-cancel</v-icon> Odmítnout
                </v-btn>
            </div>
        </template>
    </notification-item>
</template>

<script>
    import { ACCEPT_JOIN_REQUEST, DECLINE_JOIN_REQUEST } from '../../../store/actions/team'
    import NotificationMixin from '../NotificationMixin';

    export default {
        name: 'TeamRequest',
        mixins: [NotificationMixin],
        data () {
            return {
                accepting: false,
                declining: false,
            };
        },
        computed: {
            requestId () {
                return this.data.payload.requestId;
            },
        },
        methods: {
            async accept () {
                try {
                    this.accepting = true;
                    await this.$store.dispatch('team/' + ACCEPT_JOIN_REQUEST, { requestId: this.requestId });
                    this.$toast.success('Žádost byla přijata.');
                    this.hide();
                } catch (e) {
                    const message = e.response.data.message || 'Při přijetí žádosti došlo k chybě. Zkuste to později.';
                    this.$toast.error(message);
                } finally {
                    this.accepting = false;
                }
            },
            async decline () {
                try {
                    this.declining = true;
                    await this.$store.dispatch('team/' + DECLINE_JOIN_REQUEST, { requestId: this.requestId });
                    this.$toast.success('Žádost byla zamítnuta.');
                    this.hide();
                } catch (e) {
                    this.$toast.error('Při odmítnutí žádosti došlo k chybě. Zkuste to později.');
                } finally {
                    this.declining = false;
                }
            },
        },
    }
</script>
